import { Link } from 'react-router-dom'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Loading } from '@/components/shared/Loading'
import type { UserSummary } from '@/types'
import { CHARACTER_INFO } from '@/types/user'
import { formatDateTime, formatRelativeTime } from '@/utils/formatDate'
import { formatNumber } from '@/utils/formatNumber'

interface UserTableProps {
  users: UserSummary[]
  loading: boolean
}

export function UserTable({ users, loading }: UserTableProps) {
  if (loading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loading text="사용자 로딩 중..." />
      </div>
    )
  }

  if (users.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center text-muted-foreground">
        사용자가 없습니다
      </div>
    )
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>사용자</TableHead>
          <TableHead>캐릭터</TableHead>
          <TableHead>언어</TableHead>
          <TableHead className="text-right">메시지</TableHead>
          <TableHead className="text-right">스레드</TableHead>
          <TableHead>생성일</TableHead>
          <TableHead>최근 활동</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell>
              <Link
                to={`/users/${user.id}`}
                className="font-medium text-primary hover:underline"
              >
                {user.nickname || user.email || user.id.slice(0, 8)}
              </Link>
              {user.email && user.nickname && (
                <p className="text-xs text-muted-foreground">{user.email}</p>
              )}
            </TableCell>
            <TableCell>
              {user.character ? (
                <Badge variant="secondary">
                  {CHARACTER_INFO[user.character].emoji}{' '}
                  {CHARACTER_INFO[user.character].name}
                </Badge>
              ) : (
                <span className="text-muted-foreground">-</span>
              )}
            </TableCell>
            <TableCell>
              <Badge variant="outline">{user.language.toUpperCase()}</Badge>
            </TableCell>
            <TableCell className="text-right">
              {formatNumber(user.message_count)}
            </TableCell>
            <TableCell className="text-right">
              {formatNumber(user.thread_count)}
            </TableCell>
            <TableCell className="text-sm text-muted-foreground">
              {formatDateTime(user.created_at)}
            </TableCell>
            <TableCell className="text-sm text-muted-foreground">
              {user.last_active_at
                ? formatRelativeTime(user.last_active_at)
                : '-'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
